export const dropdownRequired = (errorMessage: string) => ({
  test: ({ value }: { value: string }) =>
    Boolean(value && value.length > 0) && value.trim() !== '',
  getErrorMessage: () => Promise.resolve(errorMessage),
  name: 'dropdownRequired',
});
